<template>
  <div class="version-page"></div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
a
  color var(--version-page-text-color)
.version-page
  position: relative;
  width: 100%;
  height: 100%;
  pointer-events auto
.dmp-aside
  position absolute
  width 320px
  left 15px
  top 15px
  bottom 10px
  border-right 1px solid var(--version-aside-border-color)
  background-color var(--version-bg-color)
  overflow auto
  .aside-menu
    font-weight: bold;
    color: var(--version-page-text-color);
    font-size 18px
    margin-top 20px
    .menu-li
      padding 5px 5px 10px 0
      box-sizing border-box
      span
        font-size 18px
    .sub-aside-menu
      box-sizing border-box
      font-weight: normal;
      color var(--version-page-text-color)
      margin-top 10px
      .sub-menu-li
        font-size 15px
        padding 6px 5px 6px 28px
        box-sizing border-box
        border-left 5px #fff solid
        a
          display block
          width 100%
          height 100%
        &:hover,&.active
          font-weight bold
          color #1c83ff
          border-left 5px #1c83ff solid
          a
            color #1c83ff
.dmp-main
  position absolute
  top 15px
  right 15px
  left 336px
  bottom 10px
  color var(--version-page-text-color)
  background-color var(--version-bg-color)
  overflow auto
  .version-content
    max-width: 800px;
    margin: 0 auto;
    padding: 10px 15px;
h1
  font-size 36px
  margin 10px 0 10px
h2
  font-size: 28px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eaecef;
h1, h2, h3, h4, h5, h6
  font-weight: 600;
.custom-block.tip
    padding: 16px 24px;
    border-left-width: 8px;
    border-left-style: solid;
    margin: 16px 0;
    background-color: var(--version-custom-block-bg);
    border-color: #1c83ff;
    .custom-block-title
      margin-top 8px
      margin-bottom 8px
      font-size 16px
      font-weight bold
    .funtion-list
      font-size 16px
      line-height 28px
      padding 0 4px
.service-table
  border 1px solid grey
  border-collapse collapse
  border-spacing: 2px;
  td,th
    border: 1px solid #dfe2e5;
    padding: 10px 15px;
    font-size 16px
    text-align center
  tr:nth-child(2n)
    background-color var(--version-tr-even-bg)
</style>
